export const COMPANY = {
  name: "Jonaren Technologies And Trading LLC",
  shortName: "Jonaren Technologies",
  tagline: "Tech & Trade",
  logo: "/logo.png",
  address:
    "Shams Business Centre, Sharjah Media City Free Zone, Al Messaned, Sharjah, United Arab Emirates",
  phone: "+971 50 336 7406",
  phoneHref: "tel:+971503367406",
  email: "info@jonarenuae.com",
  hours: "Sunday - Thursday, 9:00 AM - 6:00 PM (GST)",
  linkedin: "https://www.linkedin.com/company/jonaren-tech",
};

export const GROUP = {
  name: "Jonaren Group",
  intro:
    "Jonaren Group brings together two technology companies operating across the Middle East and India. Together we combine deep engineering expertise with regional trading capability to deliver end-to-end technology solutions to enterprises worldwide.",
  companies: [
    {
      name: "Jonaren Technologies And Trading LLC",
      location: "Sharjah, United Arab Emirates",
      region: "Middle East & Africa",
      description:
        "Our UAE entity serving the GCC region with IT consulting, digital transformation, enterprise applications and technology trading services from Sharjah Media City Free Zone.",
      website: "jonarenuae.com",
      highlights: ["IT Consulting", "Technology Trading", "Managed Services", "Cloud & Networking"],
    },
    {
      name: "Jonaren Technology Pvt Ltd",
      location: "Bangalore & Noida, India",
      region: "India & Global Delivery",
      description:
        "Founded in 2010, our Indian engineering hub delivers product engineering, data & AI, mobile and web development with a proven global delivery model.",
      website: "jntechno.com",
      highlights: ["Product Engineering", "Data & AI", "Mobile Experience", "Digital Marketing"],
    },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1653549893012-b8b4fbe97630?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heroAlt: "https://images.unsplash.com/photo-1518980120692-3cfe64c152d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  about: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  team: "https://images.unsplash.com/photo-1573496130141-209d200cebd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  datacenter: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  servers: "https://images.pexels.com/photos/17489163/pexels-photo-17489163.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  careers: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const STATS = [
  { value: 15, suffix: "+", label: "Years of Excellence" },
  { value: 250, suffix: "+", label: "Projects Delivered" },
  { value: 30, suffix: "+", label: "Countries Served" },
  { value: 98, suffix: "%", label: "Client Retention" },
];

export const HERO_WORDS = ["Innovation", "Technology", "Digital", "Growth"];

export const ENABLE_TABS = [
  {
    key: "connected",
    label: "Connected",
    title: "Connected Enterprise",
    description:
      "We connect people, processes, devices and data across your organization. From IoT-enabled operations to integrated enterprise platforms, we help you build a truly connected business that responds in real time.",
    points: ["IoT & Edge Integration", "Enterprise System Integration", "Real-time Data Pipelines", "API-first Architecture"],
    image: IMAGES.datacenter,
  },
  {
    key: "personalized",
    label: "Personalized",
    title: "Personalized Experiences",
    description:
      "Harness data and AI to deliver tailored experiences at every touchpoint. We build recommendation engines, customer data platforms and intelligent journeys that treat every customer as an individual.",
    points: ["Customer Data Platforms", "AI-driven Recommendations", "Behavioural Analytics", "Journey Orchestration"],
    image: IMAGES.team,
  },
  {
    key: "interactive",
    label: "Interactive",
    title: "Interactive Engagement",
    description:
      "Conversational AI, chatbots, AR/VR and immersive interfaces that turn passive users into active participants. We design engagement models that keep customers coming back.",
    points: ["Conversational AI", "Extended Reality (AR/VR)", "Voice & NLU", "Gamified Interfaces"],
    image: IMAGES.heroAlt,
  },
  {
    key: "omnichannel",
    label: "Omnichannel",
    title: "Omnichannel Commerce",
    description:
      "Seamless, consistent experiences across web, mobile, social, in-store and contact centre. We unify channels so customers can start anywhere and finish everywhere.",
    points: ["Unified Commerce Platforms", "Content & Portals", "Order Management", "Loyalty Platforms"],
    image: IMAGES.about,
  },
  {
    key: "on-go",
    label: "Customer On Go",
    title: "Customer On The Go",
    description:
      "Mobile-first experiences for a workforce and customer base that never stands still. Native, cross-platform and progressive web apps engineered for performance and delight.",
    points: ["Native iOS & Android", "Cross-platform Apps", "Progressive Web Apps", "Mobile Backend & APIs"],
    image: IMAGES.careers,
  },
];

export const MISSION =
  "Our mission is to serve as the essential technical partner for small and medium-sized organizations and individuals. We are committed to delivering comprehensive and cost-effective digital solutions with speed and efficiency, enabling them to build a robust online presence and achieve their full business potential.";

export const VISION =
  "We envision a world where every small and medium-sized business, regardless of size or location, has access to the highest quality technical solutions. Our goal is to serve as their trusted partner, enabling them to achieve their full potential in the digital landscape.";

export const SERVICE_STEPS = [
  {
    number: "01",
    title: "Design Experiences, Providing Advice",
    items: ["Strategy & Consulting", "Design Thinking", "Customer Journey", "User Experience", "Digital Marketing", "Business Insights"],
  },
  {
    number: "02",
    title: "Experience Touchpoints",
    items: ["Mobile Apps", "Web Portals", "Chatbots", "Social Media", "Email", "NLU & Visualization"],
  },
  {
    number: "03",
    title: "Digital Solutions & Engineering",
    items: ["Oracle CX", "SAP", "Order Management", "CRM Platforms", "Loyalty Platforms", "Auction Platforms"],
  },
  {
    number: "04",
    title: "Advanced Digital Solutions",
    items: ["RPA", "Cybersecurity", "IoT", "Blockchain", "Agile", "Cloud", "DevOps", "Microservices", "AI & ML"],
  },
  {
    number: "05",
    title: "Infrastructure for Experiences",
    items: ["5G", "Wi-Fi", "Edge Cloud", "Network Virtualization", "Infrastructure Automation", "Embedded & Semiconductors", "Big Data & Analytics"],
  },
];

export const TMT = {
  title: "Technology, Media, and Telecommunication.",
  description:
    "Our comprehensive services equip TMT (Technology, Media, and Telecommunications) companies to confidently navigate today's dynamic business landscape. We provide end-to-end solutions that enhance operational efficiency, drive innovation, and empower organizations to remain competitive in rapidly evolving markets. By integrating advanced digital strategies, we enable businesses to adapt quickly, optimize resources, and overcome industry challenges with agility.",
};

export const PRODUCTS = [
  { name: "Jonaren Learn", subtitle: "Learning Experience Platform", icon: "GraduationCap" },
  { name: "Chatbots", subtitle: "Conversational AI Platform", icon: "MessageSquare" },
  { name: "XPARK", subtitle: "Design-Led Product Innovation", icon: "Sparkles" },
  { name: "Omnicare", subtitle: "Digital Health Platform", icon: "HeartPulse" },
  { name: "Automation Orchestration", subtitle: "Intelligent Process Automation", icon: "Workflow" },
  { name: "Edge Cloud", subtitle: "Distributed Cloud Infrastructure", icon: "Cloud" },
  { name: "Virtual CPE", subtitle: "Virtualized Customer Premises", icon: "Router" },
  { name: "Digital Experience Assessment", subtitle: "Maturity & Readiness Audit", icon: "ClipboardCheck" },
];

export const RESOURCES = [
  { title: "Brochure", description: "Explore our latest digital solutions and services.", icon: "BookOpen" },
  { title: "WhitePaper", description: "Insights on technology trends shaping the future.", icon: "FileText" },
  { title: "Newsroom", description: "Updates and stories on innovation and growth.", icon: "Newspaper" },
  { title: "eBooks", description: "In-depth knowledge for business and digital success.", icon: "Library" },
];

const slug = (s) =>
  s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const mk = (title, description) => ({ title, slug: slug(title), description });

export const OFFERING_GROUPS = [
  {
    group: "Digital Experience & Innovations",
    icon: "Palette",
    items: [
      mk("Consulting & Strategy", "We partner with leadership teams to define digital strategy, prioritize investments and build roadmaps that convert vision into measurable business outcomes."),
      mk("Customer Experience", "At Jonaren Technologies, we prioritize customers and users, uncovering key opportunities for digital transformation and helping businesses understand the needs of those central to their products and services."),
      mk("User Experience & Design", "Human-centred design that blends research, design thinking and rapid prototyping to craft intuitive interfaces people love to use."),
      mk("Content, Commerce & Portals", "Enterprise content management, digital commerce and self-service portals that unify your brand story and drive conversion across channels."),
      mk("Extended Reality (AR/VR)", "Immersive AR/VR solutions for training, remote assistance, retail and product visualization that bring digital experiences into the physical world."),
      mk("Mobile Experience", "Native, cross-platform and progressive mobile applications engineered for performance, security and delightful user engagement."),
    ],
  },
  {
    group: "Enterprise Modernization",
    icon: "Building2",
    items: [
      mk("Cloud Transformation", "Cloud is pivotal in driving today's digital transformation, offering flexibility, scalability, security, performance and reliability. We help enterprises modernize technology, create new revenue streams and accelerate product releases through the cloud."),
      mk("Enterprise Automation", "RPA, intelligent document processing and workflow automation that eliminate manual effort, reduce errors and free your teams to focus on high-value work."),
      mk("Connected Enterprise", "Integrate systems, devices and data across the organization to create a responsive, insight-driven enterprise."),
      mk("Platform Engineering", "Internal developer platforms, CI/CD pipelines and infrastructure-as-code that boost developer productivity and release velocity."),
      mk("Enterprise Agility", "Elevate your organization with Enterprise Agile Transformation Programs, instilling best practices and cultural shifts across projects, programs and portfolios."),
      mk("Internet of Things", "End-to-end IoT solutions from sensors and edge gateways to cloud platforms and analytics dashboards."),
    ],
  },
  {
    group: "Product Engineering",
    icon: "Cpu",
    items: [
      mk("Product Design & Development", "From concept to launch, we design and engineer digital products with modern architectures, agile delivery and a relentless focus on quality."),
      mk("Product Modernization", "Re-platform, re-architect and refactor legacy products to cloud-native, microservices-based architectures without disrupting your business."),
      mk("Quality Engineering & Automation", "Shift-left quality with test automation, performance engineering and continuous testing embedded in your delivery pipeline."),
      mk("Product Sustenance & Support", "Dedicated sustenance teams that maintain, enhance and support your products across their entire lifecycle."),
      mk("Hardware Engineering", "Board design, FPGA, signal integrity and hardware validation services for next-generation electronics."),
      mk("Embedded Engineering", "Firmware, RTOS, device drivers and embedded Linux development for connected devices and industrial systems."),
      mk("Cybersecurity Assurance", "Our Cyber Security COE offers Information Systems Security Governance & Consulting, Audit, and Intrusion & Security Testing to safeguard your digital assets."),
    ],
  },
  {
    group: "Data & Intelligence",
    icon: "BrainCircuit",
    items: [
      mk("Data Platform Engineering", "Modern data lakes, warehouses and streaming platforms that turn fragmented data into a trusted enterprise asset."),
      mk("Analytics & Business Intelligence", "Self-service BI, executive dashboards and advanced analytics that put actionable insight in the hands of decision makers."),
      mk("Artificial Intelligence & Machine Learning", "Applied AI/ML solutions - from predictive models and computer vision to generative AI - that create real competitive advantage."),
    ],
  },
  {
    group: "Cloud & Networking",
    icon: "Network",
    items: [
      mk("Security", "Zero-trust architectures, SOC services and security engineering that protect your infrastructure, applications and data."),
      mk("Edge Cloud", "Distributed edge computing platforms that bring compute closer to users and devices for ultra-low latency experiences."),
      mk("Network Transformation", "SDN, NFV and 5G-ready network modernization for telecom operators and large enterprises."),
      mk("Automation Orchestration", "Closed-loop network and infrastructure automation that reduces operational cost and improves reliability."),
      mk("System Integration", "Seamless integration of heterogeneous systems, platforms and partners into a coherent enterprise landscape."),
    ],
  },
  {
    group: "Enterprise Application",
    icon: "LayoutGrid",
    items: [
      mk("Oracle", "Oracle Cloud ERP, CX and database services - implementation, migration and managed support."),
      mk("Microsoft", "Dynamics 365, Azure and Microsoft 365 solutions that modernize operations and empower your workforce."),
      mk("SAP", "SAP S/4HANA transformation, integration and support delivered by certified consultants."),
      mk("Workplace", "Modern digital workplace solutions - collaboration, identity and endpoint management - for hybrid teams."),
      mk("Salesforce", "Sales, Service and Marketing Cloud implementations that put customers at the centre of your business."),
    ],
  },
  {
    group: "Infrastructure Managed Services",
    icon: "ServerCog",
    items: [
      mk("Strategic IT Consulting", "Technology advisory, IT roadmaps and governance frameworks that align IT investments with business strategy."),
      mk("IT Managed Services", "24x7 monitoring, infrastructure management, service desk and application support with SLA-backed delivery."),
    ],
  },
];

export const ALL_OFFERINGS = OFFERING_GROUPS.flatMap((g) => g.items.map((i) => ({ ...i, group: g.group })));

export const OFFERING_CAPABILITIES = [
  {
    title: "Crafting, Sustaining, and Enhancing Applications",
    description:
      "We design, build, and continuously improve applications to ensure your business stays ahead with robust, scalable, and innovative solutions tailored to your needs.",
    icon: "Code2",
  },
  {
    title: "Managing and Optimizing IT Networks",
    description:
      "Jonaren Technologies fortifies institutions with a comprehensive Network and Infrastructure Management suite. Our solutions forge secure, agile, and scalable IT frameworks, driving differentiated value.",
    icon: "Network",
  },
  {
    title: "Agile Consulting & Transformation",
    description:
      "Elevate your organization with our Enterprise Agile Transformation Programs, instilling best practices and fostering cultural shifts across projects, programs, and portfolios.",
    icon: "Rocket",
  },
  {
    title: "Cybersecurity and IT Protection",
    description:
      "Our Cyber Security COE offers comprehensive Information Systems Security Governance & Consulting, Audit, and Intrusion & Security Testing services to safeguard your digital assets.",
    icon: "ShieldCheck",
  },
  {
    title: "Compliance and Regulation Solutions",
    description:
      "Our regulatory consultants are adept at aiding entities in managing compliance gaps, consumer privacy, regulatory readiness, and audit adherence. Stay ahead of regulatory shifts with expert guidance.",
    icon: "Scale",
  },
  {
    title: "Process Optimization & PMO Leadership",
    description:
      "Harnessing a global presence and comprehensive expertise in Project, Program, Portfolio, and Change Management, we seamlessly support R&D, IT, and Transformation endeavors for global enterprises.",
    icon: "GitBranch",
  },
];

export const INDUSTRIES = [
  {
    title: "Telecom",
    slug: "telecom",
    icon: "RadioTower",
    image: "https://images.unsplash.com/photo-1643155193188-38eb08e2b54f?auto=format&fit=crop&w=900&q=80",
    summary: "Next-gen network engineering, 5G and digital services for operators and equipment makers.",
    description: [
      "Jonaren Technologies pioneers cutting-edge product and solution engineering, empowering telecom operators to deliver digital services beyond mere connectivity. Our innovations enhance performance and revenue for Telcos and equipment makers, elevating market impact.",
      "Leveraging our proven framework and innovative tools, we aid telecom operators and equipment manufacturers in swiftly transitioning to next-gen networks. From 5G to AI, our expertise in Edge Computing, IoT, and more drives efficiency, reducing time-to-market and costs.",
    ],
  },
  {
    title: "Travel and Hospitality",
    slug: "travel-and-hospitality",
    icon: "Plane",
    image: "https://images.unsplash.com/photo-1561131668-f63504fc549d?auto=format&fit=crop&w=900&q=80",
    summary: "Guest-centric digital platforms, booking engines and loyalty solutions.",
    description: [
      "Travellers expect frictionless, personalized journeys from search to check-out. Jonaren Technologies helps airlines, hotels and travel platforms build digital experiences that anticipate guest needs and drive loyalty.",
      "From booking and revenue management systems to mobile concierge apps and IoT-enabled smart rooms, we modernize hospitality technology to increase occupancy, ancillary revenue and guest satisfaction.",
    ],
  },
  {
    title: "Media and Entertainment",
    slug: "media-and-entertainment",
    icon: "Clapperboard",
    image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?auto=format&fit=crop&w=900&q=80",
    summary: "OTT platforms, content workflows and audience analytics for the streaming era.",
    description: [
      "Media companies compete for attention across every screen. We engineer OTT and streaming platforms, content management systems and monetization engines that scale to millions of concurrent users.",
      "Our data and AI capabilities power recommendation engines, audience segmentation and ad-tech integrations that maximize engagement and revenue per user.",
    ],
  },
  {
    title: "Healthcare",
    slug: "healthcare",
    icon: "HeartPulse",
    image: "https://images.unsplash.com/photo-1666886573301-b5d526cfd518?auto=format&fit=crop&w=900&q=80",
    summary: "Digital health platforms, interoperability and patient engagement solutions.",
    description: [
      "Healthcare providers and payers are under pressure to deliver better outcomes at lower cost. Jonaren Technologies builds secure, compliant digital health platforms - including our Omnicare product - that connect patients, clinicians and data.",
      "We deliver EHR integrations (HL7/FHIR), telehealth, remote patient monitoring and analytics solutions that improve care coordination while meeting stringent privacy regulations.",
    ],
  },
  {
    title: "Banking, Financial Services and Insurance",
    slug: "banking-financial-services-and-insurance",
    icon: "Landmark",
    image: "https://images.unsplash.com/photo-1572883454114-1cf0031ede2a?auto=format&fit=crop&w=900&q=80",
    summary: "Secure, compliant and agile IT frameworks for banks, insurers and fintechs.",
    description: [
      "Jonaren Technologies fortifies Banking & Financial institutions with a comprehensive Network and Infrastructure Management suite. Our solutions forge secure, agile, and scalable IT frameworks, driving differentiated value.",
      "Our regulatory consultants aid banking and financial entities in managing compliance gaps, consumer privacy, regulatory readiness, and audit adherence - keeping you ahead of evolving industry standards.",
    ],
  },
  {
    title: "Semiconductor",
    slug: "semiconductor",
    icon: "Cpu",
    image: "https://images.unsplash.com/photo-1562408590-e32931084e23?auto=format&fit=crop&w=900&q=80",
    summary: "Hardware, embedded and verification engineering for chip makers.",
    description: [
      "Semiconductor companies face shrinking design cycles and rising complexity. Our hardware and embedded engineering teams provide board design, firmware, driver development and validation services that accelerate silicon-to-market.",
      "We support post-silicon validation, reference platform development and software enablement so your customers can adopt your silicon faster.",
    ],
  },
  {
    title: "Network Infrastructure",
    slug: "network-infrastructure",
    icon: "Network",
    image: "https://images.unsplash.com/photo-1594915440248-1e419eba6611?auto=format&fit=crop&w=900&q=80",
    summary: "SDN/NFV, edge cloud and automation for infrastructure providers.",
    description: [
      "Network infrastructure providers must deliver more capacity with greater agility. Jonaren Technologies brings deep expertise in SDN, NFV, virtual CPE and edge cloud to modernize network architectures.",
      "Our automation orchestration solutions enable closed-loop operations, reducing manual intervention and operational expense while improving reliability.",
    ],
  },
  {
    title: "Retail & E-Commerce",
    slug: "retail-and-e-commerce",
    icon: "ShoppingBag",
    image: "https://images.unsplash.com/photo-1511317559916-56d5ddb62563?auto=format&fit=crop&w=900&q=80",
    summary: "Omnichannel commerce, order management and personalization at scale.",
    description: [
      "Retailers need to unify online and offline experiences. We build omnichannel commerce platforms, order management systems and loyalty programs that deliver consistent, personalized shopping journeys.",
      "With data-driven merchandising, inventory intelligence and AI-powered recommendations, we help retailers grow basket size and customer lifetime value.",
    ],
  },
];

export const WORKS = [
  { title: "Building Data Analytics For Software Development", category: "Data & Analytics", date: "28 Aug, 2025", image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=900&q=80", summary: "Engineering-analytics platform that surfaces velocity, quality and delivery insights for a global software organization." },
  { title: "Supply Chain, Logistics & Transportation", category: "Enterprise Modernization", date: "29 Aug, 2025", image: "https://images.unsplash.com/photo-1678182451047-196f22a4143e?auto=format&fit=crop&w=900&q=80", summary: "End-to-end visibility platform integrating fleet telematics, warehouse systems and customer portals." },
  { title: "Retail & e-Commerce", category: "Digital Experience", date: "29 Aug, 2025", image: "https://images.unsplash.com/photo-1511317559916-56d5ddb62563?auto=format&fit=crop&w=900&q=80", summary: "Omnichannel commerce transformation with unified order management and personalized storefronts." },
  { title: "Banking, Financial Services and Insurance", category: "Cybersecurity & Compliance", date: "29 Aug, 2025", image: "https://images.unsplash.com/photo-1572883454114-1cf0031ede2a?auto=format&fit=crop&w=900&q=80", summary: "Secure network & infrastructure management suite with regulatory compliance automation for a regional bank." },
  { title: "Telecom", category: "Network Transformation", date: "29 Aug, 2025", image: "https://images.unsplash.com/photo-1643155193188-38eb08e2b54f?auto=format&fit=crop&w=900&q=80", summary: "5G-ready network modernization and closed-loop automation for a tier-1 telecom operator." },
  { title: "Network Infrastructure", category: "Cloud & Networking", date: "29 Aug, 2025", image: "https://images.unsplash.com/photo-1594915440248-1e419eba6611?auto=format&fit=crop&w=900&q=80", summary: "Edge cloud and virtual CPE deployment enabling low-latency enterprise services." },
  { title: "Healthcare Digital Platform", category: "Digital Health", date: "30 Aug, 2025", image: "https://images.unsplash.com/photo-1666886573301-b5d526cfd518?auto=format&fit=crop&w=900&q=80", summary: "Omnicare-based patient engagement and telehealth rollout across a multi-facility provider network." },
  { title: "Hardware Engineering", category: "Product Engineering", date: "29 Aug, 2025", image: "https://images.unsplash.com/photo-1562408590-e32931084e23?auto=format&fit=crop&w=900&q=80", summary: "Reference board design and validation for a next-generation semiconductor platform." },
  { title: "Embedded Engineering", category: "Product Engineering", date: "29 Aug, 2025", image: "https://images.unsplash.com/photo-1677092419414-e974582c492c?auto=format&fit=crop&w=900&q=80", summary: "Firmware and embedded Linux development for an industrial IoT gateway product line." },
];

export const BLOGS = [
  { title: "How Generative AI Is Reshaping Enterprise Software Delivery", category: "Artificial Intelligence", date: "12 Sep, 2025", readTime: "6 min read", image: "https://images.unsplash.com/photo-1518980120692-3cfe64c152d0?auto=format&fit=crop&w=900&q=80", excerpt: "From code generation to intelligent testing, generative AI is compressing delivery cycles. Here is how enterprises can adopt it responsibly." },
  { title: "Cloud Transformation in the GCC: A Practical Roadmap", category: "Cloud", date: "02 Sep, 2025", readTime: "8 min read", image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=900&q=80", excerpt: "Data residency, sovereignty and hybrid architectures - what regional enterprises need to plan for in their cloud journey." },
  { title: "Zero Trust Security for the Connected Enterprise", category: "Cybersecurity", date: "21 Aug, 2025", readTime: "5 min read", image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=900&q=80", excerpt: "Perimeter-based security is dead. Learn the principles and phased approach to implementing zero trust across your infrastructure." },
  { title: "Designing Omnichannel Journeys Customers Actually Love", category: "Customer Experience", date: "10 Aug, 2025", readTime: "7 min read", image: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?auto=format&fit=crop&w=900&q=80", excerpt: "Unified commerce is more than integrating channels - it is about designing for the moments that matter in a customer's journey." },
  { title: "5G, Edge and the Future of Network Automation", category: "Telecom", date: "28 Jul, 2025", readTime: "6 min read", image: "https://images.unsplash.com/photo-1643155193188-38eb08e2b54f?auto=format&fit=crop&w=900&q=80", excerpt: "Why closed-loop automation is essential for operators looking to monetize 5G and edge investments." },
  { title: "Building a Data Platform That Scales With Your Business", category: "Data & Intelligence", date: "15 Jul, 2025", readTime: "9 min read", image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=900&q=80", excerpt: "Lakehouse, streaming and governance - the architectural decisions that determine whether your data platform becomes an asset or a liability." },
];

export const CAREER_ENABLEMENT = [
  { title: "Jonaren Revamp", icon: "RefreshCw", description: "Ready to rejoin the corporate world and propel your career forward? Whatever the reason for your break - passion, sabbatical, parenthood - we have an opportunity for you. We understand the importance of personal priorities and offer a seamless return to work." },
  { title: "Skilled Experts", icon: "Award", description: "Discover your potential with diverse career paths across various technology fields at Jonaren Technologies. If you are a skilled IT professional with broad experience in technology platforms, seize the opportunity to join our team." },
  { title: "College Graduates", icon: "GraduationCap", description: "Are you enthusiastic about information technology? Recently graduated? Begin your career journey with Jonaren Technologies, a renowned solutions provider with deep expertise in IT and digital transformation." },
];

export const LIFE_AT = [
  { title: "Originality Pledge", icon: "Lightbulb", description: "We prioritize both employee and organizational growth. Our nurturing atmosphere promotes work-life balance and prioritizes mental and physical well-being." },
  { title: "Essence: Our Guiding Principles", icon: "Compass", description: "Our culture thrives on trust, ethics, integrity, and expertise. Operating globally across 30+ countries, our diversity strengthens us, embracing cultures and differences worldwide." },
  { title: "Staff Perks", icon: "Gift", description: "As you flourish, so do we. Our benefits prioritize physical, emotional, financial, and social wellness - remote work, flexible hours, rewards, and career advancement." },
  { title: "Unity in Diversity", icon: "Users", description: "Diversity and inclusion are non-negotiables. We draw insights from a rich tapestry of perspectives: race, age, gender, nationality, and more." },
  { title: "Female Strength", icon: "Heart", description: "Women hold key positions and make up a substantial part of our team. We foster a culture where women can thrive and contribute diverse perspectives." },
];

export const OPENINGS = [
  { title: "Software Engineer", location: "Sharjah, UAE / Remote", type: "Full-time", description: "We are seeking a highly skilled software engineer to join our team. The ideal candidate will have a strong background in computer science and software engineering with experience developing cloud-based applications." },
  { title: "Cloud Solutions Architect", location: "Sharjah, UAE", type: "Full-time", description: "Design and lead cloud transformation engagements for enterprise clients across the GCC. Experience with Azure, AWS or OCI and hybrid architectures required." },
  { title: "Business Development Manager - IT Services", location: "Sharjah, UAE", type: "Full-time", description: "Drive growth for our IT consulting and technology trading business across the UAE and wider Middle East. Strong enterprise network preferred." },
  { title: "Data & AI Engineer", location: "Bangalore, India / Remote", type: "Full-time", description: "Build modern data platforms and ML pipelines for global clients. Hands-on experience with Python, Spark and cloud data services." },
];

export const WHY_US = [
  { title: "Regional Presence, Global Delivery", icon: "Globe2", description: "UAE-based consulting backed by a mature engineering hub in India delivers the best of local understanding and global scale." },
  { title: "End-to-End Capability", icon: "Layers", description: "From strategy and design through engineering, cloud and managed services - one accountable partner across the lifecycle." },
  { title: "Security & Compliance First", icon: "ShieldCheck", description: "Every engagement is built on secure-by-design principles and regional regulatory awareness." },
  { title: "Outcome-Driven Engagement", icon: "Target", description: "We measure ourselves on your business results - not billable hours." },
];

export const TESTIMONIALS = [
  { quote: "Jonaren transformed our fragmented legacy systems into a unified cloud platform in under nine months. Their team felt like an extension of ours.", name: "Chief Technology Officer", company: "Regional Retail Group, UAE" },
  { quote: "The network automation work delivered by Jonaren reduced our operational incidents by over 40%. Exceptional engineering rigour.", name: "Head of Network Operations", company: "Telecom Operator, GCC" },
  { quote: "From strategy to execution, Jonaren brought clarity to our digital roadmap and delivered every milestone on time.", name: "Director of Digital", company: "Healthcare Provider, India" },
];

export const PARTNERS = ["Microsoft", "Oracle", "SAP", "Salesforce", "AWS", "Google Cloud", "Cisco", "VMware"];

export const DIRECTOR = {
  name: "Managing Director",
  title: "Jonaren Technologies And Trading LLC",
  image: "/director.jpg",
  quote: "Technology should never be a barrier to ambition. Our purpose is to make world-class engineering accessible to every organization that dares to grow.",
  message: [
    "When we established Jonaren Technologies And Trading LLC in the United Arab Emirates, our vision was simple yet ambitious: to bring the proven engineering excellence of Jonaren Group closer to the businesses shaping the future of the Middle East. The region is undergoing one of the most remarkable digital transformations in the world, and we are privileged to be part of that journey.",
    "At Jonaren, we believe that trust is earned through outcomes. Every engagement we undertake - whether a cloud transformation, a product build or a managed services partnership - is measured against a single question: did we create lasting value for our client? This philosophy guides our people, our processes and our partnerships.",
    "I am deeply grateful to our clients for their confidence, to our partners for their collaboration and to our team for their relentless commitment to quality. Together, we will continue to innovate responsibly, deliver with integrity and help our clients turn technology into a genuine competitive advantage.",
  ],
  signoff: "Warm regards,",
};
